import { render, staticRenderFns } from "./points_task_evaluation.vue?vue&type=template&id=1cc9b210&scoped=true"
import script from "./points_task_evaluation.vue?vue&type=script&lang=js"
export * from "./points_task_evaluation.vue?vue&type=script&lang=js"
import style0 from "./points_task_evaluation.vue?vue&type=style&index=0&id=1cc9b210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9b210",
  null
  
)

export default component.exports